<template>
    <div class="template_wrapper">
      <!--计算描述的高度-->
      <div style="position:fixed;top: 10000px;">
        <div style="width:398px;word-wrap:break-word" ref="computed_content">
          {{content}}
        </div>
      </div>
       <div class="template_title"><span style="color:red;vertical-align: top;" v-if="moduel.required==1" >*</span>{{moduel.name}}</div>
        <!-- <quill-editor
            v-model="content"
            ref="myQuillEditor"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @change="onEditorChange($event)">
        </quill-editor> -->
        <div style="display: inline-block;">
           <!-- <vue-ueditor-wrap v-model="content" :config="myConfig" :destroy="true" @ready="ready"></vue-ueditor-wrap>-->
        </div> 
        <!-- <span style="color:red;vertical-align: top;" v-if="moduel.required==1" >*</span>a -->
    </div>
</template>
<style>
   .template_title{
        vertical-align: top;
   }
</style>

<script>
// import { quillEditor } from "vue-quill-editor"; //调用编辑器
// import 'quill/dist/quill.core.css';
// import 'quill/dist/quill.snow.css';
// import 'quill/dist/quill.bubble.css';
export default {
    // components: {
    //     quillEditor
    // },
    data() {
        return {
            content: "",
            content_height: 0,
             myConfig: {
            // 编辑器不自动被内容撑高
            autoHeightEnabled: false,
            // 初始容器高度
            initialFrameHeight: 240,
            // 初始容器宽度
            initialFrameWidth: '90%',
            toolbars: [
                ['fontsize', 'bold', 'italic','|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist',]
              ],
            insertorderedlist:{
              'num': '1,2,3...',
            },
            insertunorderedlist :{
              'disc': '● 小黑点',
            }
          },
          editor: null
        }
    },
    props: ['moduel', 'data','type', "input_callback"],
    methods: {
        clear(){
          this.content = '';
        },
        ready: function(_editor){
          this.editor = _editor;
          this.editor.addListener("contentChange", this.listener);
        },
        listener: function(_event){
          console.log(_event);
          console.log(this.editor.getContent())
        }
    },
    destroyed(){
        this.clear();
    },
    mounted() {
        if(this.data[this.moduel.key_name] != ''){
            if(this.data[this.moduel.key_name] !=null) {
              this.content = this.data[this.moduel.key_name];
            }
        }
    },
    watch: {
      'content':{
        handler(newName, oldName) {
          console.log("watch",newName, oldName);
          var that =this;
          this.$nextTick(function(){
            var _content_height = that.$refs["computed_content"].offsetHeight;
            that.content_height = _content_height;
            this.$emit('input',this.content);
            this.$emit('listenToChildEvent',this.type);
          });
        },
        immediate: true
      }
    },
    computed: {
        editor() {
            return this.$refs.myQuillEditor.quill;
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/editor.vue